import { useMutation } from '@tanstack/react-query'
import { useAuthStore } from '@/store/authStore'
import { toast } from 'react-toastify'
import { authApi } from '@/services/auth/authApi'
import { handleError } from '@/utils/helpers'

export const useGoogleLogin = () => {
  const setAuth = useAuthStore((state) => state.setAuth)

  return useMutation({
    mutationFn: async ({
      code,
      codeVerifier,
      redirectUri,
      state,
    }: {
      code: string
      codeVerifier: string
      redirectUri: string
      state?: string
    }) => {
      // Exchange authorization code for tokens using PKCE
      const loginResponse = await authApi.googleLogin(code, codeVerifier, redirectUri, state)

      // Store tokens in localStorage
      localStorage.setItem('token', loginResponse.token)
      localStorage.setItem('refreshToken', loginResponse.refreshToken)

      return loginResponse
    },
    onSuccess: (data) => {
      const { token, refreshToken, user } = data

      // Store user data, tokens and auth provider
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('refreshToken', refreshToken)
      localStorage.setItem('auth_provider', 'google')

      setAuth({
        isAuthenticated: true,
        token,
        user,
      })

      toast.success('Đăng nhập Google thành công!')
    },
    onError: (error: Error) => {
      handleError(error, { fallbackMessage: 'Lỗi đăng nhập Google' })
    },
  })
}
